import { render, staticRenderFns } from "./NotFoundRoute.vue?vue&type=template&id=3ec59f1a&scoped=true&"
import script from "./NotFoundRoute.vue?vue&type=script&lang=ts&"
export * from "./NotFoundRoute.vue?vue&type=script&lang=ts&"
import style0 from "./NotFoundRoute.vue?vue&type=style&index=0&id=3ec59f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec59f1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VContainer,VIcon,VSheet})
